<main-app-header></main-app-header>
<app-breadcrumbs></app-breadcrumbs>
<div class="wrapper">
  <!-- <div class="payment-header">
    <div class="payment-logo">
      <img src="./assets/images/logo.png" />
      <span style="padding-top: 0px !important; font-size: 0.5rem !important; margin-left: 45px !important; margin-top:5px!important" class="trademark">™</span>
      <h3>Manage Plan</h3>
    </div>
  </div> -->
  <div class="container">
    <div *ngIf="startSection">
      <div *ngIf="planName === 'Dependant'" class="plan-card">
        <div class="plan-card__header">
          <div>
            <div class="plan-card__label">Subscription access</div>

            <div class="plan-card__value">
              You are a {{ logged_user_role }} 
              <ng-container *ngIf="logged_user_role === 'Manager'; else groupSub">
                on {{ owner_display_name }}’s subscription
              </ng-container>
              <ng-template #groupSub>of a group subscription</ng-template>
            </div>

            <div class="plan-card__sub">
              As a dependant, you can create your own subscription at any time.
            </div>
          </div>

          <div class="plan-card__actions">
            <a data-aos="fade-up" data-aos-anchor-placement="bottom-bottom" (click)="openConfirmModal(confirmCreateTpl)"
              class="btn btn-orange banner-btn pointer">
              Create my own subscription
            </a>
          </div>
        </div>
      </div>

      <!-- Confirmation modal template (unchanged API) -->
      <ng-template #confirmCreateTpl let-modal>
        <div class="modal-header">
          <h4 class="modal-title">Confirm</h4>
          <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
          Creating your own subscription will remove you from
          <strong>{{ owner_display_name }}</strong>’s group.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Go Back</button>
          <button type="button" class="btn btn-primary" (click)="modal.close()">Continue</button>
        </div>
      </ng-template>
      <!-- <div *ngIf="planName != 'Dependant' && canChangePlan()">
        <h3>Current plan:
          <br><span *ngIf="planName != 'Individual'">{{ totalSeatsGET }} seats at ${{ pricePerSeat }} per seat per
            month</span>
          <br><span *ngIf="planName == 'Individual'"> Individual</span>
        </h3>
        <div class="banner-btn-container">
          <div class="buttonPadding"><a id="dashButton" [routerLink]="[ '/change-payment' ]"
              routerLinkActive="active" class="btn btn-blue submitBtn">Change/Update Payment</a></div>
          <div class="buttonPadding"><a id="dashButton" [routerLink]="[ '/subscription-cancel' ]"
              routerLinkActive="active" class="btn btn-blue submitBtn">Cancel Subscription</a></div>
     
          <a data-aos="fade-up" data-aos-anchor-placement="bottom-bottom" (click)="upgradePlan()"
            routerLinkActive="active" class="btn btn-orange banner-btn pointer">Change Plan</a>
        </div>
      </div> -->
      <!-- Current Plan Card -->
      <div *ngIf="planName != 'Dependant' && canChangePlan()" class="plan-card">
        <div class="plan-card__header">
          <div>
            <!-- Label -->
            <div class="plan-card__label">Current Subscription</div>

            <!-- Value line -->
            <div class="plan-card__value" *ngIf="planName !== 'Individual'">
              <strong>{{ totalSeatsGET }}</strong> seats
              <span class="plan-card__dot">•</span>
              <strong>${{ pricePerSeat }}</strong> / seat / month
            </div>
            <div class="plan-card__value" *ngIf="planName === 'Individual'">
              <strong>Individual</strong>
            </div>
          </div>

          <!-- Primary actions -->
          <div class="plan-card__actions">
            <a [routerLink]="['/change-payment']" routerLinkActive="active" class="btn btn-blue submitBtn">Change
              Payment</a>
            <a [routerLink]="['/subscription-cancel']" routerLinkActive="active" class="btn btn-blue submitBtn">Cancel
              Subscription</a>
            <button type="button" (click)="upgradePlan()" class="btn btn-orange banner-btn">Change Subscription</button>
          </div>
        </div>

        <!-- Secondary actions (NEW) -->
        <div class="plan-card__footer">
          <!-- Existing add-users flow preserved -->
          <!-- <button type="button" class="btn btn-orange submitBtn" (click)="openModal()">Add Users</button> -->

          <!-- NEW: quick manage users shortcut -->
          <!-- <a [routerLink]="['/dashboard']" class="btn btn-blue submitBtn">Manage Users</a> -->

          <!-- NEW: billing history -->
          <!-- <a [routerLink]="['/billing-history']" class="btn btn-blue submitBtn">Billing History</a>

    
    <a [routerLink]="['/usage']" class="btn btn-blue submitBtn">Usage & Seats</a> -->
        </div>
      </div>


    </div>
  </div>
  <div class="thankyou-bg privacy-policy-bg">
    <div class="logo otp-label-1"><a [routerLink]="['/dashboard']" style="visibility: hidden;"><img
          src="./assets/images/logo.png" /></a>
      <span style="margin-top:-20px; visibility:hidden;" class="trademark2">™</span>
    </div>
    <!-- <div class="backlink pointer"><a (click)="backClicked()"><i class="fas fa-chevron-left"></i>{{ upgradePlanCheck ?
        'Back' : 'Back' }}</a></div> -->

    <div>
      <div *ngIf="upgradePlanCheck" class="thankyou-box privacy-policy-box" style="max-width: 1950px!important">
        <div class="map-form">
          <section style="padding:0px !important;">
            <h3 class="topText" style="color: red;">Select a Subscription</h3>
            <p class="downgrade-label" style="color: white;">To downgrade a Subscription please empty seats to the desired subscription
              range!</p>
            <div class="grid-plan-two-tiles section3">
              <div class="grid-plan-two-tile mobile-tabled-tile-padding"
                [ngClass]="{'selected': selectedPlan === 'Individual'}" (click)="selectPlan('Individual')">
                <h3 class="general-font-size" style="margin-top:10px;"><span>Individual</span></h3>
                <div>
                </div>
                <ul class="checkmark-list">
                  <li>$6</li>
                </ul>
                <a style=" bottom: 0;" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom"
                  routerLinkActive="active" class="btn btn-orange banner-btn">Choose Subscription</a>
              </div>
              <div class="grid-plan-two-tile mobile-tabled-tile-padding"
                [ngClass]="{'selected': selectedPlan === '2-4 users'}" (click)="selectPlan('2-4 users')">
                <h3 class="general-font-size" style="margin-top:10px;"><span>2-4 users</span></h3>
                <div>
                </div>
                <ul class="checkmark-list">
                  <li>$5</li>
                </ul>
                <a style="bottom: 0;" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom"
                  routerLinkActive="active" class="btn btn-orange banner-btn">Choose plan</a>
              </div>
              <div class="grid-plan-two-tile mobile-tabled-tile-padding"
                [ngClass]="{'selected': selectedPlan === '5-50 users'}" (click)="selectPlan('5-50 users')">
                <h3 class="general-font-size" style="margin-top:10px;"><span>5-50 users</span></h3>
                <div>
                </div>
                <ul class="checkmark-list">
                  <li>$4</li>
                </ul>
                <a style="bottom: 0;" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom"
                  routerLinkActive="active" class="btn btn-orange banner-btn">Choose Subscription</a>
              </div>
              <div class="grid-plan-two-tile mobile-tabled-tile-padding"
                [ngClass]="{'selected': selectedPlan === '51-300 users'}" (click)="selectPlan('51-300 users')">
                <h3 class="general-font-size" style="margin-top:10px;"><span>51-300 users</span></h3>
                <div>
                </div>
                <ul class="checkmark-list">
                  <li>$3</li>
                </ul>
                <a style="bottom: 0;" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom"
                  routerLinkActive="active" class="btn btn-orange banner-btn">Choose Subscription</a>
              </div>
              <div class="grid-plan-two-tile mobile-tabled-tile-padding"
                [ngClass]="{'selected': selectedPlan === '301-unlimited users'}"
                (click)="selectPlan('301-unlimited users')">
                <h3 class="general-font-size" style="margin-top:10px;"><span>301-unlimited users</span></h3>
                <div>
                </div>
                <ul class="checkmark-list">
                  <li>$2</li>
                </ul>
                <a style="bottom: 0;" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom"
                  routerLinkActive="active" class="btn btn-orange banner-btn">Choose Subscription</a>
              </div>
            </div>

          </section>
          <div class="login-form-group" [@slideInOut]>
            <div class="form-group">
              <div id="emailOrPhoneCheck">
                <form autocomplete="on" [formGroup]="planForm" id="signup-form">
                  <ul>
                    <li class="plan-details plan-padding" style="display:grid">
                      <!-- <h3 class="topText" style="color: red;">Current subscription {{totalSeatsGET}} at {{pricePerAdditionalSeat}}$ per seat.</h3> -->

                      <!--<select formControlName="plan_option"
                              [ngClass]="(fp['plan_option']?.errors?.required ? 'form-error' : '')">
                        <option value="" disabled>Plan type</option>
                        <option value="Individual" [disabled]="ind_check">Individual</option>
                        <option value="2-4 users" [disabled]="second_check">2-4 users/$5 per seat</option>
                        <option value="5-50 users" [disabled]="third_check">5-50 users/$4 per seat</option>
                        <option value="51-300 users" [disabled]="fourth_check">51-300 users/$3 per seat</option>
                        <option value="301-unlimited users" [disabled]="fifth_check">
                          301-unlimited users/$2 per seat
                        </option>
                      </select>-->
                      <h3 class="topText" style="color: red;">Number of seats</h3>
                      <select formControlName="number_seats"
                        [ngClass]="(fp['number_seats']?.errors?.required ? 'form-error' : '')">
                        <option value="" disabled selected>Seats</option>
                        <option *ngIf="individualPlan" value="0">0</option>
                        <option *ngIf="familyOrSmallOfficePlan" value="2">2</option>
                        <option *ngIf="familyOrSmallOfficePlan" value="3">3</option>
                        <option *ngIf="familyOrSmallOfficePlan" value="4">4</option>
                        <option *ngIf="smallBusinessPlan" value="5">5</option>
                        <option *ngIf="smallBusinessPlan" value="6">6</option>
                        <option *ngIf="smallBusinessPlan" value="7">7</option>
                        <option *ngIf="smallBusinessPlan" value="8">8</option>
                        <option *ngIf="smallBusinessPlan" value="9">9</option>
                        <option *ngIf="smallBusinessPlan" value="10">10</option>
                        <option *ngIf="smallBusinessPlan" value="11">11</option>
                        <option *ngIf="smallBusinessPlan" value="12">12</option>
                        <option *ngIf="smallBusinessPlan" value="13">13</option>
                        <option *ngIf="smallBusinessPlan" value="14">14</option>
                        <option *ngIf="smallBusinessPlan" value="15">15</option>
                        <option *ngIf="smallBusinessPlan" value="16">16</option>
                        <option *ngIf="smallBusinessPlan" value="17">17</option>
                        <option *ngIf="smallBusinessPlan" value="18">18</option>
                        <option *ngIf="smallBusinessPlan" value="19">19</option>
                        <option *ngIf="smallBusinessPlan" value="20">20</option>
                        <option *ngIf="smallBusinessPlan" value="21">21</option>
                        <option *ngIf="smallBusinessPlan" value="22">22</option>
                        <option *ngIf="smallBusinessPlan" value="23">23</option>
                        <option *ngIf="smallBusinessPlan" value="24">24</option>
                        <option *ngIf="smallBusinessPlan" value="25">25</option>
                        <option *ngIf="smallBusinessPlan" value="26">26</option>
                        <option *ngIf="smallBusinessPlan" value="27">27</option>
                        <option *ngIf="smallBusinessPlan" value="28">28</option>
                        <option *ngIf="smallBusinessPlan" value="29">29</option>
                        <option *ngIf="smallBusinessPlan" value="30">30</option>
                        <option *ngIf="smallBusinessPlan" value="31">31</option>
                        <option *ngIf="smallBusinessPlan" value="32">32</option>
                        <option *ngIf="smallBusinessPlan" value="33">33</option>
                        <option *ngIf="smallBusinessPlan" value="34">34</option>
                        <option *ngIf="smallBusinessPlan" value="35">35</option>
                        <option *ngIf="smallBusinessPlan" value="36">36</option>
                        <option *ngIf="smallBusinessPlan" value="37">37</option>
                        <option *ngIf="smallBusinessPlan" value="38">38</option>
                        <option *ngIf="smallBusinessPlan" value="39">39</option>
                        <option *ngIf="smallBusinessPlan" value="40">40</option>
                        <option *ngIf="smallBusinessPlan" value="41">41</option>
                        <option *ngIf="smallBusinessPlan" value="42">42</option>
                        <option *ngIf="smallBusinessPlan" value="43">43</option>
                        <option *ngIf="smallBusinessPlan" value="44">44</option>
                        <option *ngIf="smallBusinessPlan" value="45">45</option>
                        <option *ngIf="smallBusinessPlan" value="46">46</option>
                        <option *ngIf="smallBusinessPlan" value="47">47</option>
                        <option *ngIf="smallBusinessPlan" value="48">48</option>
                        <option *ngIf="smallBusinessPlan" value="49">49</option>
                        <option *ngIf="smallBusinessPlan" value="50">50</option>
                        <option *ngIf="midSizeBusinessPlan" value="51">51</option>
                        <option *ngIf="enterprisePlan" value="301">301</option>
                      </select>
                    </li>
                    <li *ngIf="error" class="show__alert__message" style="padding-bottom: 5px;">
                      <div class="alert alert-danger">
                        {{error}}
                      </div>
                    </li>
                    <li *ngIf="additionalSeats">
                      <input type="number" pattern="[0-9]*" formControlName="additional_seats" name="additional_seats"
                        min="0" max="249" placeholder="Additional seats" />
                    </li>
                    <li *ngIf="errorSeats" class="show__alert__message">
                      <div class="alert alert-danger">
                        {{errorSeats}}
                      </div>
                    </li>
                    <li class="login-form plan-padding">
                      <input type="submit" autocomplete="off" [disabled]="!planForm.valid || disableButton"
                        (click)="paymentScreen()" class="btn btn-orange submitBtn" name="submit" value="Confirm" />
                    </li>
                  </ul>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="payment" class="form-group plan-box-shadow" style="font-size:17px">
        <div class="subcription-amount">
          <div class="amount">
            <div>
              <span>$</span> <strong> {{newPlanPrice}}</strong><br />
            </div>
            <span class="amount-label">Per Month.</span>
          </div>
          <div class="subscription-des">
            <h4 class="try-text">{{planSelected}}</h4>
            <h4 *ngIf="!individualPlan" class="try-text">Users: {{totalSeatsCount}}</h4>

          </div>
        </div>
        <h3 class="topText">Please enter your credit card details.</h3>
        <form [formGroup]="creditCardForm" (ngSubmit)="onSubmit()" id="cc-form">
          <ul>
            <li>
              <input
                [ngClass]="( ccSubmit && ccf['cardNumber']?.errors?.required || ccSubmit && ccf['cardNumber']?.errors?.ccNumber ? 'form-error' : '')"
                type="text" maxlength="20" type="tel" formControlName="cardNumber" #ccNumber="ccNumber"
                autocomplete="cc-number" ccNumber placeholder="Credit Card Number">

              <!-- {{ccNumber.resolvedScheme$ | async}} -->
            </li>
            <li *ngIf="ccf.cardNumber.touched && ccf.cardNumber.invalid">
              <div *ngIf="ccf.cardNumber.hasError('required') || ccf.cardNumber.hasError('ccNumber')">
                <div class="text-danger">
                  Invalid Card Number!
                </div>
              </div>
            </li>
            <li class="card-details">
              <select formControlName="month" class="plan-background-color"
                [ngClass]="( ccSubmit && ccf['month']?.errors?.required ? 'form-error' : '')">
                <option value="" disabled selected>MM</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
              <select formControlName="year" class="plan-background-color"
                      [ngClass]="( ccSubmit && ccf['year']?.errors?.required ? 'form-error' : '')">
                <option value="" disabled selected>YY</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
                <option value="2031">2031</option>
                <option value="2032">2032</option>
                <option value="2033">2033</option>
                <option value="2034">2034</option>
                <option value="2035">2035</option>
              </select>
              <input [ngClass]="( ccSubmit && ccf['cardCode']?.errors?.required ? 'form-error' : '')" type="text"
                maxlength="4" name="cardCode" formControlName="cardCode" type="tel" autocomplete="off" ccCvc
                placeholder="CVV">
              <i class="fas fa-info-circle"></i>
            </li>
            <li *ngIf="ccf.month.touched && ccf.month.invalid || ccf.year.touched && ccf.year.invalid">
              <div *ngIf="ccf.month.hasError('required') || ccf.year.hasError('required')">
                <div class="text-danger">
                  Expiration date Is Required!
                </div>
              </div>
            </li>
            <li *ngIf="ccf.cardCode.touched && ccf.cardCode.invalid">
              <div *ngIf="ccf.cardCode.hasError('required')">
                <div class="text-danger">
                  CVV Number Is Required!
                </div>
              </div>
            </li>
            <li>
              <input [ngClass]="( ccSubmit && ccf['fullName']?.errors?.required ? 'form-error' : '')" type="text"
                name="fullName" formControlName="fullName" placeholder="Full Name on Credit or Debit card">

            </li>
            <li *ngIf="ccf.fullName.touched && ccf.fullName.invalid">
              <div *ngIf="ccf.fullName.hasError('required')">
                <div class="text-danger">
                  Full Name Is Required!
                </div>
              </div>
            </li>
            <li>
              <input [ngClass]="( ccSubmit && ccf['zip']?.errors?.required ? 'form-error' : '')" type="text"
                maxlength="15" name="zip" formControlName="zip" placeholder="Postal Code">
            </li>
            <li *ngIf="ccf.zip.touched && ccf.zip.invalid">
              <div *ngIf="ccf.zip.hasError('required')">
                <div class="text-danger">
                  Postal Code Is Required!
                </div>
              </div>
            </li>
            <li class="login-form">
              <input type="submit" [disabled]="!creditCardForm.valid" class="btn btn-orange submitBtn" name="submit"
                value="Confirm">
            </li>
            <li *ngIf="error" class="show__alert__message">
              <div class="alert alert-danger">
                {{error}}
              </div>
            </li>
          </ul>
        </form>
      </div>
      <div>
      </div>
    </div>
  </div>
</div>
